
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public",
      function () {
        return require("private-next-pages/public/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public"])
      });
    }
  